import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const editClubShipmentItems = (customerId, shipmentId, payload) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/items`,
    payload,
    axiosHeaderV2()
  );

export const getSubscriptionClubShipmentVirtualCart = (
  customerId,
  clubSubscriptionShipmentId
) =>
  axios.get(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${clubSubscriptionShipmentId}/virtual-cart`,
    axiosHeaderV2()
  );

export const getClubSubscriptionShipmentVirtualCartLimited = (
  clubSubscriptionShipmentId
) =>
  axios.get(
    `${getV2RootUrl()}/club-subscription-shipment/${clubSubscriptionShipmentId}/virtual-cart/limited`,
    axiosHeaderV2()
  );

export const editClubVirtualShipmentItems = (customerId, shipmentId, payload) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/virtual-cart`,
    payload,
    axiosHeaderV2()
  );

export const processClubShipment = (customerId, shipmentId) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/process`,
    {},
    axiosHeaderV2()
  );

export const skipClubShipment = (customerId, shipmentId) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/skip`,
    {},
    axiosHeaderV2()
  );

export const unskipClubShipment = (customerId, shipmentId) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/unskip`,
    {},
    axiosHeaderV2()
  );
